<a
  style="cursor: pointer"
  class="list-group-item clearfix"
  (click)="onPlay()"
  [style.backgroundColor]="isActive ? 'lightgreen' : 'white'"
>
  <div class="pull-left">
    <h6 class="list-group-item-heading">{{ melody.name | translate }}</h6>
    <!-- <p class="list-group-item-text">{{ melody.ratios.join(' --- ') }}</p> -->
  </div></a
>
